import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import { taskTypes } from "../../../common/parameters";

import routing from "../../routing";

import { Item, Arrow } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const Breadcrumb = ({
    pack,
    packId,
    plan,
    planId,
    taskIndex,
    taskType,
    browse,
    className,
    classId,
    moderatorView,
    lang,
}: IProps) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            {pack &&
                (packId ? (
                    <Link to={"/" + routing.pack + "/" + packId}>
                        <Item name={pack} link />
                    </Link>
                ) : (
                    <Item name={pack} />
                ))}
            {className && (
                <Link to={"/" + routing.classes + "/" + classId}>
                    <Item name={className} link />
                </Link>
            )}

            {browse && !moderatorView && (
                <Link to={"/" + routing.browse}>
                    <Item name={<FormattedMessage {...messages.browse} />} link />
                </Link>
            )}
            {browse && moderatorView && (
                <Link to={"/" + routing.testModeration}>
                    <Item name={<FormattedMessage {...messages.testModeration} />} link />
                </Link>
            )}
            {plan && <Arrow />}
            {plan &&
                (planId ? (
                    <Link
                        to={
                            "/" +
                            (moderatorView ? routing.testModeration : browse ? routing.publicPlan : routing.plan) +
                            "/" +
                            planId
                        }
                    >
                        <Item name={plan} link lang={lang} />
                    </Link>
                ) : (
                    <Item name={plan} lang={lang} />
                ))}

            {taskIndex !== undefined && <Arrow />}
            {taskIndex !== undefined && (
                <span>
                    <Item name={`${taskIndex + 1}.`} marginRight={4} />
                </span>
            )}
            {taskIndex !== undefined && <Item name={taskTypes(formatMessage)[taskType!]} />}
        </div>
    );
}

export default Breadcrumb;
